export default "__VITE_ASSET__CaLTJRvF__"